import { STRATEGIES_ACTIONS } from '../Strategies/StrategiesActions.js';
import { Logger } from '../logging/Logger.js';
import { SingletonSharedData } from "../Singletons/SingletonSharedData";
import { LIST_STATES } from '../constants/constants.js';
let sharedData = new SingletonSharedData();

export function ProcessMessage(message, that) {
	if (message.Sender === 2) {
		if (that.state.logged) {
			that.logOut();
		} else {
			that.stateMachineDown();
		}
		return;
	}
	sharedData.setIsAssisted(false);
	switch (message.action) {
		case 'state':
			if (message.currentState === LIST_STATES.PROBLEM) {
				sharedData.setCurrentState(message.currentState);
				that.svrEvents.onChangeStatus(message);
				return;
			}
			that.callStateAction(message);
			break;

		case "UPDATE_DATA_CALL":
			STRATEGIES_ACTIONS[message.action](message, that);
			break;
		case 'ALERT':
			if (message.Code === '2021') {
				if (STRATEGIES_ACTIONS[message.Module]) {
					STRATEGIES_ACTIONS[message.Module](message, that);
				}
			} else {
				console.warn('[App][processMessage] Alert Not implement ', message.action);
			}
			break;
		case 'DISCONNECT':
			Logger.Warn('[AgentSDK] [Error] DISCONNECT State Machine is logout System in reconnect');
			that.messageDisconnect();
			break;
		case 'RECONNECTED':
			Logger.Debug('[SDK][processMessage] State machine is up');
			that.state.smReady = true;
			break;
		default:
			if (STRATEGIES_ACTIONS[message.action]) {
				STRATEGIES_ACTIONS[message.action](message, that);
			} else {
				Logger.Warn('[App][processMessage] Action Not implement ', message.action);
			}
			break;
	}
}
